(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('SummaryReportV2Controller', ["$scope", "modulesManager", "secAppsStatusDao", "path", "sideMenuManager", "feature", function ($scope, modulesManager, secAppsStatusDao, path, sideMenuManager, feature) {
        $scope.sideMenuManager = sideMenuManager;
        if (feature.checkpointTheme) {
            $scope.logo = path('gui-v2').directive('side-menu-v2').imgRel('check-point-print-logo.png');
        } else if (feature.lastlineTheme) {
            $scope.logo = path('gui-v2').directive('side-menu-v2').imgRel('lastline-logo-white.png');
        } else if (feature.sonicwallTheme) {
            $scope.logo = path('gui-v2').directive('side-menu-v2').imgRel('sonicwall-logo-white.png');
        } else {
            $scope.tryCustomLogo = true;
            $scope.logo = path('gui-v2').directive('side-menu-v2').imgRel('logo-dark-grey.svg');
        }
        $scope.addedValueWidget = {
            logic: {
                name: 'appsAddedValueLogic',
                updateTick: null
            },
            type: 'multi-widget',
            wrapper: {
                type: 'widget-panel',
                class: 'overflow-auto',
                title: 'Security Stack Global Coverage Analysis',
                showLoading: true,
                isLoading: true
            }
        };
        $scope.loaded = false;
        $scope.loadedSecurityApps = false;
        function loadData() {
            return modulesManager.refreshStates().then(function () {
                $scope.saasList = modulesManager.activeSaasApps();
                secAppsStatusDao.license().then(function (response) {
                    $scope.securityApps = _(modulesManager.activeSecAppsFull()).chain().filter(function (app) {
                        return response.data[app.name];
                    }).sortBy(function (app) {
                        return parseInt(app.security_stack_order);
                    }).value();
                    $scope.loadedSecurityApps = true;
                });
                $scope.loaded = true;
            });
        }
        loadData();
    }]);
}());